/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/* <img src={toAbsoluteUrl("/media/logos/logoHeader.png") } className='mt-2' style={{width: "324px", height: "55px", }} /> */}
    </div>
  );
}
